<app-navbar></app-navbar>

<section class="min-h-[50dvh] bg-white text-black">
    <div class="w-full">
        <figure class="relative">
            <img src="/assets/img/excellence/tire_knowledge/658423494373cdeefc9ba88e_TK_Basics-p-1080.jpg" alt="card image" class="object-cover bg-center w-full h-[60dvh] md:h-[45dvh]"/>
            <figcaption class="absolute bottom-0 left-0 w-full p-6 text-white bg-gradient-to-t from-neutral-950 text-left mx-auto pb-14">
                <div class="max-w-3xl xl:max-w-6xl mx-auto items-center justify-center">
                    <a routerLink="/excellence/tire-knowledge" href="/excellence/tire-knowledge" class="text-green-500 font-semibold text-lg hover:underline">{{back}}</a>
                    <h3 class="text-5xl md:text-6xl font-bold text-green-500">{{texts.title}}</h3>
                    <p class="text-2xl opacity-75 mx-auto">{{texts.subtitle}}</p>
                
                </div>
                
            </figcaption>
        </figure>
    </div>

    <div class="max-w-3xl xl:max-w-6xl mx-4 md:mx-auto py-10">
        <div class="text-justify mb-10">
            <div>
                <h2 class="text-3xl font-bold mb-4">{{texts.section_one.body[0]}}</h2>
                <p class="text-lg text-gray-700">
                    {{texts.section_one.body[1]}}
                </p>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-4 gap-2 text-center my-6">
                <div class="border-b-2 border-green-500">
                    <p class="font-semibold">{{texts.section_one.body[2].title}}</p>
                    <p class="mb-2">{{texts.section_one.body[2].body}}</p>
                </div>
                <div class="border-b-2 border-green-500">
                    <p class="font-semibold">{{texts.section_one.body[3].title}}</p>
                    <p class="mb-2">{{texts.section_one.body[3].body}}</p>
                </div>
                <div class="border-b-2 border-green-500">
                    <p class="font-semibold">{{texts.section_one.body[4].title}}</p>
                    <p class="mb-2">{{texts.section_one.body[4].body}}</p>
                </div>
                <div class="border-b-2 border-green-500">
                    <p class="font-semibold">{{texts.section_one.body[5].title}}</p>
                    <p class="mb-2">{{texts.section_one.body[5].body}}</p>
                </div>
            </div>

            <div class="mt-16 mb-4">
                <h2 class="text-3xl font-bold mb-4">{{texts.section_two.body[0]}}</h2>
                <p class="text-lg text-gray-700">
                    {{texts.section_two.body[1]}}
                </p>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-2 text-center my-6">
                <div class="border-b-2 border-green-500">
                    <p class="font-semibold">{{texts.section_two.body[2].title}}</p>
                    <p class="mb-2">{{texts.section_two.body[2].body}}</p>
                </div>
                <div class="border-b-2 border-green-500">
                    <p class="font-semibold">{{texts.section_two.body[3].title}}</p>
                    <p class="mb-2">{{texts.section_two.body[3].body}}</p>
                </div>
                <div class="border-b-2 border-green-500">
                    <p class="font-semibold">{{texts.section_two.body[4].title}}</p>
                    <p class="mb-2">{{texts.section_two.body[4].body}}</p>
                </div>
                <div class="border-b-2 border-green-500">
                    <p class="font-semibold">{{texts.section_two.body[5].title}}</p>
                    <p class="mb-2">{{texts.section_two.body[5].body}}</p>
                </div>
                <div class="border-b-2 border-green-500">
                    <p class="font-semibold">{{texts.section_two.body[6].title}}</p>
                    <p class="mb-2">{{texts.section_two.body[6].body}}</p>
                </div>
                <div class="border-b-2 border-green-500">
                    <p class="font-semibold">{{texts.section_two.body[7].title}}</p>
                    <p class="mb-2">{{texts.section_two.body[7].body}}</p>
                </div>

            </div>
            
        </div>
    </div>
</section>

<app-footer></app-footer>